import axios from 'axios'
import router from '@/router'
import {
  getToken,
  getRefreshToken,
  setToken,
  setRefreshToken,
  removeToken,
  removeRefreshToken,
  removeUserRealName
} from '@/utils/auth'
import { ElNotification } from 'element-plus'
import {
  AccountRefreshToken
} from '@/api/account'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
})
// 如果產生400 錯誤則不要進行message，則是由全部回傳給前端自行判斷的請求清單
// const skipErrorMsgUrl = []

// request interceptor
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
      config.headers['Access-Control-Allow-Origin'] = '*'
    }
    return config
  },
  error => {
    // do something with request error
    console.log('Api Request Error:', error) // for debug
    return Promise.reject(new Error(error))
  }
)

let isRefreshing = false
let requests = []

function showErrorNotification(message) {
  ElNotification({
    title: message,
    type: 'error',
    duration: 2000
  })
}
// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    const msg = res.returnMsg
    // if the custom code is not 200, it is judged as an error.
    if (res.returnCode !== '200') {
      if (res.returnCode === '403') {
        if (res.returnMsg.includes('權限不足')) {
          showErrorNotification(msg)
        } else {
          showErrorNotification(msg)
          setTimeout(() => {
            removeToken()
            removeRefreshToken()
            removeUserRealName()
            router.push('/login')
            return Promise.reject(new Error(res.returnMsg || 'Error'))
          }, 1000)
        }
      } else {
        // if error msg contain chinese str then show the ex
        /[\u4e00-\u9fa5]/.test(res.returnMsg)
          ? showErrorNotification(msg)
          : console.log(res.returnMsg)
      }
      return Promise.reject(new Error(res.returnMsg || 'Error'))
    } else {
      return res
    }
  },
  async error => {
    if (error.response.status === 400) {
      let msg = '產生例外狀況！請重新嘗試！'
      const errorMessages = {
        'One or more validation errors occurred.': '尚有必填欄位未填寫，請重新檢查'
      }
      if (error.response?.data?.title) {
        msg = errorMessages[error.response.data.title] || msg
      }
      ElNotification({
        title: msg,
        type: 'error',
        duration: 2000
      })
    }
    // eslint-disable-next-line no-empty
    if (error.response.status === 401) {
      const config = error.response.config
      if (!isRefreshing) {
        isRefreshing = true
        return AccountRefreshToken(getRefreshToken()).then(response => {
          const config = error.response.config
          const {
            data
          } = response
          // 更新 token
          setToken(data.token)
          setRefreshToken(data.refreshToken)
          config.headers['Authorization'] = 'Bearer ' + data.token
          // 取得更新token後，將排隊中的requests重新呼叫一遍
          requests.forEach(c => c(data.token))
          // 清空已呼叫require
          requests = []
          return service(config)
        }).catch(res => {
          removeToken()
          removeRefreshToken()
          removeUserRealName()
          router.push('/login')
        }).finally(() => {
          isRefreshing = false
        })
      } else {
        // 正在刷新token，返回一个未執行resolve的promise
        return new Promise((resolve) => {
          // 將resolve放進陣列中，用一个函数形式進行保存，等token刷新後直接執行
          requests.push((token) => {
            config.headers['Authorization'] = 'Bearer ' + token
            resolve(service(config))
          })
        })
      }
    }
    return Promise.reject(new Error(error))
  }
)
export default service
